import React from 'react'
import {removeStorage} from './utilities'

function isToday(date: Date): boolean {
  return date.setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0)
}

// Funcion para revisar si la fecha es menor a hoy mas x minutos
function isTimeLessThanMinutes(date: Date, minutes: number): boolean {
  return (
    date &&
    date.getTime() < new Date(new Date().setMinutes(new Date().getMinutes() + minutes)).getTime()
  )
}

function logOut() {
  if (!process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY) return
  removeStorage(process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY)
  window.location.reload()
}

export {isToday, isTimeLessThanMinutes, logOut}
